// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_zzn","left":"styles_left__2NW2f","desktopActions":"styles_desktopActions__1bflO","title":"styles_title__B22jI"};